<template>
	<tag-template 
		class="heading"
		:class="{
			[`heading--${lineX}`]: true
		}"
		:tag="tag"
	>
		{{ title }}
	</tag-template>
</template>

<script>
	export default {
		props: {
			tag: {
				default: 'h1',
				type: String
			},
			title: {
				default: 'Title',
				type: String
			},
			lineX: {
				default: 'center', // left or center
				type: String
			}
		}
	}
</script>

<style lang="scss">
	@import "~@/styles/mixins";

	.heading {
		text-align: center;
		font-size: 2.125rem;
		font-weight: 300;
		line-height: 1;
		text-transform: uppercase;
		letter-spacing: 0.2rem;
		color: var(--color-heading-text);

		@include tablet() {
			font-size: 2.8125rem;
		}

		&:after {
			content: '';
			display: block;
			width: 1.875rem;
			height: 0.0625rem;
			margin: 1.5625rem auto 2.5rem;
			background-color: var(--color-heading-underline);

			@include tablet() {
				margin-top: 2.1875rem;
				margin-bottom: 3.75rem;
			}

			@include desktop() {
				margin-bottom: 5rem;
			} 
		}

		&--left {
			text-align: left;

			&:after {
				margin-left: 0;
				margin-right: 0;
			}
		}
	}
</style>
